import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class VnMappingImportService {

  constructor(private ws: PostmethodService) { }

  bulkUploadOutlet(formData: FormData) {
    return this.ws.wsPostFile(formData, environment.baseUrl + "reports/bulkImportVnMapping");
  }
}
